<template>
  <section class="home-testimonials">
    <h3>Here is what our customers are saying</h3>
    <div class="carousel-container">
      <button @click.stop.prevent="prevSlide" aria-label="previous slide" class="nav-button">
        <font-awesome-icon :icon="['fas', 'arrow-left']" />
      </button>
      <div class="testimonial-cards">
        <div
          v-for="review in visibleReviews"
          :key="review.originalIndex"
          class="testimonial-card"
        >
          <h2>{{ review.author_name }}</h2>
          <!-- <div class="rating">
            <span v-for="value in review.rating" :key="value">
              <font-awesome-icon :icon="['fas', 'star']" />
            </span>
          </div> -->
          <p>{{ review.review }}</p>
        </div>
      </div>
      <button @click.stop.prevent="nextSlide" aria-label="next slide" class="nav-button">
        <font-awesome-icon :icon="['fas', 'arrow-right']" />
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "CarouselItem",
  components: {},

  data() {
    return {
      reviews: [
        {
          author_name: "Emma Pym",
          review:
            "We are so grateful to Earth to Oven for catering our wedding party. The food service ran sooo smoothly and it’s all thanks to the team’s hard work. The menu was also absolutely delicious and people are still talking about it when we speak with them about the evening!!… I’m certain the curry sauce chicken flatbread will always remain one of the best things I’ve ever eaten! +++ points for the team being just the loveliest, smiliest bunch! We’ll definitely seek them out at another event soon!",
        },
        {
          author_name: "David Jarvis",
          review:
            "We ordered the chicken flatbread and the venison flatbread along with the macaroni cheese bites this evening in Liss and the food was incredible. Unbelievable taste and lovely service will definitely be back again next week.",
        },
        {
          author_name: "African Fisherman",
          review:
            "E.T.O was at the pumpkin event, the staff were super friendly when I ordered my coffee. It was delicious after spending kids if time in the cold. The coffee was fantastic 👌🏻👌🏻",
        },
        {
          author_name: "C Martelosso",
          review:
            "Don’t even know how to put it, that’s how good it was. You just got to try it.",
        },
        {
          author_name: "James Goulsbra",
          review:
            "Words will never be able to truly describe the food this amazing company put together. If you want to experience food with awesome flavours and a truly fantastic taste. Then go and find where Alfie and his team are popping up and get yourself something off their menu. Using local ingredients and putting together remarkable food, they are taking street food to the next level. Go check them out.",
        },
        {
          author_name: "Henry Nash",
          review:
            "Alfie and his team provided the food at our wedding party as we wanted something a bit different. His food is incredible - his team have a talent for creating variety from locally sourced produce. People raved about the food - and are still complimenting it now!",
        },
        {
          author_name: "Sophia Jenkins",
          review:
            "The food we ate from here yesterday was absolutely delicious and I can't wait to come back and try some more of the flavour combinations. Everyone in our family of 4 really enjoyed their flatbreads and the service was so friendly and sincere. Highly recommend!",
        },
      ],
      activeSlide: 0,
      cardsPerView: 3, // Default for landscape
    };
  },
  computed: {
    visibleReviews() {
      const visible = [];
      for (let i = 0; i < this.cardsPerView; i++) {
        const index = (this.activeSlide + i) % this.reviews.length;
        visible.push({
          ...this.reviews[index],
          originalIndex: index
        });
      }
      return visible;
    }
  },
  methods: {
    prevSlide() {
      this.activeSlide = this.activeSlide === 0 ? this.reviews.length - 1 : this.activeSlide - 1;
    },
    nextSlide() {
      this.activeSlide = (this.activeSlide + 1) % this.reviews.length;
    },
    updateCardsPerView() {
      // Set cards per view based on screen orientation
      this.cardsPerView = window.matchMedia('(orientation: portrait)').matches ? 1 : 3;
    }
  },
  mounted() {
    // Set initial cards per view
    this.updateCardsPerView();
    // Listen for orientation changes
    window.addEventListener('resize', this.updateCardsPerView);
    window.addEventListener('orientationchange', this.updateCardsPerView);
  },
  beforeUnmount() {
    // Clean up event listeners
    window.removeEventListener('resize', this.updateCardsPerView);
    window.removeEventListener('orientationchange', this.updateCardsPerView);
  },
  // async created() {
  //   try {
  //     const response = await fetch("http://localhost:4242/reviews");
  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }
  //     const data = await response.json();
  //     this.reviews = data.result.reviews;
  //     // console.log("data fetched and pushed to reviews array", this.reviews);
  //   } catch (error) {
  //     console.log("Fetch error: ", error);
  //   }
  // },
};
</script>

<style lang="scss" scoped>
.home-testimonials {
  display: flex;
  margin: 1rem;
  flex-direction: column;
  min-height: 40vh;
  
  h3 {
    text-align: center;
    margin-bottom: 2rem;
  }
  
  .carousel-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    gap: 1rem;
    
    .nav-button {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 3rem;
      background: var(--background-colour);
      color: var(--text-colour);
      padding: 1rem;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      transition: all 300ms ease-in-out;
      font-size: 1.2rem;
      
      &:hover {
        box-shadow: var(--box-shadow);
        transform: scale(1.05);
      }
    }
    
    .testimonial-cards {
      display: flex;
      gap: 1.5rem;
      flex: 1;
      justify-content: center;
      align-items: stretch;
      
      .testimonial-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        background: var(--back-white);
        border-radius: 12px;
        padding: 2rem;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transition: all 300ms ease-in-out;
        flex: 1;
        min-height: 300px;
        max-width: 350px;
        
        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
        }
        
        h2 {
          color: #1a0dab;
          font-size: 1.2rem;
          margin-bottom: 1rem;
          font-weight: 600;
        }
        
        p {
          color: #333;
          font-size: 0.95rem;
          line-height: 1.5;
          margin: 0;
          flex: 1;
          display: flex;
          align-items: center;
        }
        
        .rating {
          color: var(--text-colour);
          padding: 1rem;
          font-size: 1.1rem;
        }
      }
    }
  }
}

@media only screen and (orientation: portrait) {
  .home-testimonials {
    margin: 1rem;
    
    .carousel-container {
      .nav-button {
        min-width: 2.5rem;
        padding: 0.8rem;
        font-size: 1rem;
      }
      
      .testimonial-cards {
        .testimonial-card {
          padding: 1.5rem;
          min-height: 250px;
          
          h2 {
            font-size: 1.1rem;
          }
          
          p {
            font-size: 0.9rem;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .home-testimonials {
    margin: 0.5rem;
    
    .carousel-container {
      .testimonial-cards {
        .testimonial-card {
          padding: 1rem;
          min-height: 200px;
          
          h2 {
            font-size: 1rem;
            margin-bottom: 0.8rem;
          }
          
          p {
            font-size: 0.85rem;
          }
        }
      }
    }
  }
}
</style>
